export const BENEFICIARY = {
  UPLOAD_STATUS:
    {
      INPROGRESS: 'In progress',
      PENDING: 'Pending',
      COMPLETED: 'Completed',
      TEMPLATE: 'Template',
      COMPLETEDWITHERRORS: 'Completed with errors',
      COMPLETEDWITHWARNINGS: 'Completed with warnings',
      ERROR: 'Error',
      INVALIDUPLOAD: 'Invalid Upload',
    },
  TYPE:
    {
      INDIVIDUAL: 'individual',
      COMPANY: 'company',
      TRUST: 'trust',
      MINOR: 'minor',
    },
  LOCK: 1,
  UNLOCK: 0,
  UPLOAD_MAX_FILENAME_LENGHT: 30, // use to trim long filename
  UPLOAD_MAX_FILESIZE: 20971520, // max file size upload in bytes
}



// WEBPACK FOOTER //
// ./src/constants/beneficiary.js